import WorkItemHelper from '../utils/WorkItemHelper.js';
import Formatter from '../utils/Formatter.js';
import Mapper from '../utils/Mapper.js';
import {Constants} from '../constants/WorkItemConstants';
import YourDetailsConstants from '../constants/YourDetailsConstants';

function generateApplicationConsentWorkItem(isFni, clientIp) {
    let backFile = [];
    let investorInfo = '<div class="container">', accountInfo = '<div class="container">';
    investorInfo += WorkItemHelper.generateRow('Account creation time', Constants.BackfileCustomerAccountOpeningTime + ' (AEST)');
    investorInfo += WorkItemHelper.generateRow('Application submitted via', isFni ? 'FirstNet Investor (FNI)':'Public website');
    investorInfo += WorkItemHelper.generateRow('IP address', clientIp);
    investorInfo += '</div>';

    accountInfo += WorkItemHelper.generateRow('Account number', Constants.BackfileCustomerAccountNumber);
    accountInfo += WorkItemHelper.generateRow('Account opened on', Constants.BackfileCustomerAccountOpeningTime + ' (AEST)');
    accountInfo += '</div>';
    
    backFile.push({
        id: 'BACKFILE_ACCOUNT_INFORMATION',
        title: 'Applicant consent audit log (e-Setup)',
        htmlConstruct: accountInfo
    });
    backFile.push({
        id: 'BACKFILE_INVESTOR_INFORMATION',
        title: 'Investor details',
        htmlConstruct: investorInfo
    });



    const auditBackfile = WorkItemHelper.generateFileNote('Applicant consent audit log (e-Setup)', {
        file: backFile,
        isBackFile: true
    });

    return auditBackfile;
}

function generateDigitalConsentWorkItem(request) {
    let backFile = [];
    // BackFile - Adviser & Customer Information
    let accountInfo = '<div class="container">', adviserInfo = '<div class="container">';
    accountInfo += WorkItemHelper.generateRow('Account number', Constants.BackfileCustomerAccountNumber);
    accountInfo += WorkItemHelper.generateRow('Account opened on', Constants.BackfileCustomerAccountOpeningTime + ' (AEST)');
    accountInfo += '</div>';
    adviserInfo += WorkItemHelper.generateRow('Adviser name', Constants.BackfileAdviser);
    adviserInfo += WorkItemHelper.generateRow('Dealer ID', Constants.BackfileDealerId);
    adviserInfo += WorkItemHelper.generateRow('Adviser ID', Constants.BackfileAdviserId);
    adviserInfo += '</div>';

    backFile.push({
        id: 'BACKFILE_ACCOUNT_INFORMATION',
        title: 'Digital consent audit log (e-Setup)',
        htmlConstruct: accountInfo
    });

    const investorList = request.investorList;

    for (let i = 0; i < investorList.length; i++) {
        let investorSection = '';
        const title = Mapper.getGenderTitle(investorList[i].gender, investorList[i].title, request.titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);
        const investorName = Formatter.formatFullname(title, investorList[i].givenName, investorList[i].lastName);
        investorSection += '<div class="container">';
        investorSection += WorkItemHelper.generateRow('Investor name', investorName);
        investorSection += WorkItemHelper.generateRow('Validation code (sent on)', request.netCodeSentTime + ' (AEST)');
        investorSection += WorkItemHelper.generateRow('Validation code (verified on)', request.netCodeVerificationTime + ' (AEST)');
        investorSection += WorkItemHelper.generateRow('Mobile number used', investorList[i].contactDetails.mobile);
        investorSection += '</div>';

        let investorNumber = i + 1;
        backFile.push({
            id: 'BACKFILE_DIGITAL_CONSENT_INVESTOR_' + investorList[i].investorId,
            title: 'Investor '+investorNumber+' details',
            htmlConstruct: investorSection
        });
    }

    backFile.push({
        id: 'BACKFILE_ADVISER_INFORMATION',
        title: 'Adviser details',
        htmlConstruct: adviserInfo
    });

    const auditBackfile = WorkItemHelper.generateFileNote('Digital consent audit log (e-Setup)', {
        file: backFile,
        isBackFile: true
    });

    return auditBackfile;
}


const AuditWorkItemHelper = {
    generateApplicationConsentWorkItem: generateApplicationConsentWorkItem,
    generateDigitalConsentWorkItem: generateDigitalConsentWorkItem
};

export default AuditWorkItemHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/AuditWorkItemHelper.js